(function () {

  RS.Modules.Bloomreach = {
    refQuickView: null,
    refClose: null,
    refOverlay: null,

    init: function () {
      this.refQuickView = $('.br-sf-widget-merchant-qv a');
      this.refClose = $('.br-sf-widget-merchant-popup-close a');
      this.refOverlay = $('#overlay');
      this.quickView();
    },

    quickView: function () {
      this.refQuickView.click(function () {
        $('#overlay').addClass('menuOverlay');
      });
      this.refClose.click(function () {
        $('#overlay').removeClass('menuOverlay');
      });
      this.refOverlay.click(function () {
        if (typeof(hideBrRpQv) !== 'undefined') {
          hideBrRpQv();
        }
      });
    },

  };
}());

(function () {
  RS.Modules.Bloomreach.init();
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/bloomreach.js
// module id = 325
// module chunks = 5